import { render, staticRenderFns } from "./ProductTypeInput.vue?vue&type=template&id=2e56abbf&scoped=true&"
import script from "./ProductTypeInput.vue?vue&type=script&lang=js&"
export * from "./ProductTypeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56abbf",
  null
  
)

export default component.exports